export default __webpack_public_path__ + "340c870640479370b2848e2226e2f45d.png";